import { useContext } from 'react'
import { ToastsContext } from '../contexts'

export function useToasts () {
  return useContext(ToastsContext)
}
